// extracted by mini-css-extract-plugin
export default {"site":"day_site__v7Y7l","homeLink":"day_homeLink__OrK00","canvas":"day_canvas__3V9BC","tile":"day_tile__qxhoR"};